import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { USER_LOGIN } from "../Utils/apis";
import { updateAuthenticationState } from "../Store/Slices/authStates";
import useUserSetup from "./useUserSetup";
import useRedirect from "./Auth/useRedirect";

const useLogIn = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const setupAuth = useUserSetup();
  const { redirect } = useRedirect();

  const fn = async (email, password) => {
    if (!loading) {
      try {
        setLoading(true);

        const res = await fetch(USER_LOGIN, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, password }),
          credentials: "include",
        });

        if (res.ok) {
          const user = await res.json();
          setupAuth(true);
          redirect();
        } else {
          const err = await res.json();

          throw new Error(err.error || err.message || "Something went wrong");
        }
      } catch (error) {
        dispatch(updateAuthenticationState(false));
        setError(error.message);
        return Promise.reject(error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  return [loading, error, fn];
};

export default useLogIn;
